/* eslint-disable */
/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || | 
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI - v1.1.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2023 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
// Chakra imports
import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  Image,
  useColorModeValue,
  FormErrorMessage,
  useToast,
  Link,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Select,
  Radio,
  RadioGroup,
  Switch,
  Textarea,
  Stack,
  Divider,
  useDisclosure
} from "@chakra-ui/react";
import { useNavigate } from 'react-router-dom'
// Custom components
import { HSeparator } from "components/separator/Separator";
import DefaultAuth from "layouts/auth/Default";
// Assets
import illustration from "assets/img/auth/auth.png";
import { FcGoogle } from "react-icons/fc";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";
import { Formik, Field, Form } from 'formik';
import { vercode } from '@/api/login'
import { login, getInfo, getMainChart, submitMerchantApply } from '@/api/login'
import storage from '@/utils/jeepayStorageWrapper.js'
import userStorage from '@/utils/user'
import appConfig from '@/config/appConfig'
import baseStorage from 'store'


function SignIn() {
  const navigate = useNavigate()
  // Chakra color mode
  const textColor = useColorModeValue("navy.700", "white");
  const textColorSecondary = "gray.400";
  const textColorDetails = useColorModeValue("navy.700", "secondaryGray.600");
  const textColorBrand = useColorModeValue("brand.500", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");
  const googleBg = useColorModeValue("secondaryGray.300", "whiteAlpha.200");
  const googleText = useColorModeValue("navy.700", "white");
  const googleHover = useColorModeValue(
    { bg: "gray.200" },
    { bg: "whiteAlpha.300" }
  );
  const googleActive = useColorModeValue(
    { bg: "secondaryGray.300" },
    { bg: "whiteAlpha.200" }
  );
  const [show, setShow] = React.useState(false);
  const handleClick = () => setShow(!show);
  const [vercodeImgSrc, setVercodeImgSrc] = useState('')
  const [isOverdue, setIsOverdue] = useState(false)
  const vercodeToken = useRef();
  const timer = useRef()
  const toast = useToast()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [mchData, setMchData] = useState({
    mchName: '',
    loginUserName: '',
    mchShortName: '',
    contactName: '',
    contactEmail: '',
    contactTel: '',
    type: 1,
    isvNo: '',
    state: 1,
    isRecordBalance: 1,
    remark: ''
  })
  const [isvList, setIsvList] = useState([])
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [formErrors, setFormErrors] = useState({})
  
  const refVercode = () => { // 刷新图片验证码
    // 获取图形验证码
    vercode().then(res => {
      setVercodeImgSrc(res.imageBase64Data)
      // that.vercodeImgSrc = res.imageBase64Data
      // that.vercodeToken = res.vercodeToken
      vercodeToken.current = res.vercodeToken
      setIsOverdue(true)
      // this.isOverdue = false
      if (timer.current) clearInterval(timer.current) // 如果多次点击则清除已有的定时器
      // 超过60秒提示过期刷新
      timer.current = setInterval(() => {
        res.expireTime--
        if (res.expireTime <= 0) {
          setIsOverdue(false)
          clearInterval(timer.current)
        }
      }, 1000)
    })
  }

  // 表单验证函数
  const validateForm = () => {
    let errors = {};
    let isValid = true;

    if (!mchData.mchName) {
      errors.mchName = "请输入商户名称";
      isValid = false;
    }

    if (!mchData.loginUserName) {
      errors.loginUserName = "请输入登录名";
      isValid = false;
    } else if (!/^[a-zA-Z][a-zA-Z0-9]{5,17}$/.test(mchData.loginUserName)) {
      errors.loginUserName = "请输入字母开头，长度为6-18位的登录名";
      isValid = false;
    }

    if (!mchData.mchShortName) {
      errors.mchShortName = "请输入商户简称";
      isValid = false;
    }

    if (!mchData.contactName) {
      errors.contactName = "请输入联系人姓名";
      isValid = false;
    }

    if (mchData.contactEmail && !/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(mchData.contactEmail)) {
      errors.contactEmail = "请输入正确的邮箱地址";
      isValid = false;
    }

    if (!mchData.contactTel) {
      errors.contactTel = "请输入联系人手机号";
      isValid = false;
    } else if (!/^1\d{10}$/.test(mchData.contactTel)) {
      errors.contactTel = "请输入正确的手机号";
      isValid = false;
    }

    if (mchData.type === 2 && !mchData.isvNo) {
      errors.isvNo = "请选择服务商";
      isValid = false;
    }

    setFormErrors(errors);
    return isValid;
  };

  // 获取服务商列表
  const getIsvList = () => {
    // 可以根据需要实现获取服务商列表的API调用
    // 这里暂时使用空数组
    setIsvList([])
  }

  // 提交商户开通申请
  const handleSubmitMch = () => {
    if (!validateForm()) {
      toast({
        title: '请完善表单信息',
        status: 'error'
      });
      return;
    }

    setIsSubmitting(true);
    // 调用申请商户接口
    submitMerchantApply(mchData)
      .then(res => {
        toast({
          title: '申请提交成功',
          status: 'success'
        });
        onClose();
        // 重置表单
        setMchData({
          mchName: '',
          loginUserName: '',
          mchShortName: '',
          contactName: '',
          contactEmail: '',
          contactTel: '',
          type: 1,
          isvNo: '',
          state: 1,
          isRecordBalance: 0,
          remark: ''
        });
      })
      .catch(err => {
        toast({
          title: err.msg || '申请提交失败',
          status: 'error'
        });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  }

  useEffect(() => {
    if (storage.getToken()) {
      navigate('/admin/profile')
    } else {
      refVercode()
    }

    return () => {
      clearInterval(timer.current)
    }
  }, [])

  // 添加新的useEffect用于处理抽屉打开时获取服务商列表
  useEffect(() => {
    if (isOpen) {
      getIsvList()
    }
  }, [isOpen])

  function validateEmptyVal(value, txt) {
    let error
    if (!value) {
      error = `请输入${txt}`
    }
    return error
  }
  return (
    <DefaultAuth illustrationBackground={illustration} image={illustration}>
      <Formik
        initialValues={{
          username: '',
          password: '',
          usercode: '',
        }}
        onSubmit={(values, actions) => {
          console.log(values)
          login({
            username: values.username,
            password: values.password,
            vercode: values.usercode,
            vercodeToken: vercodeToken.current,
          }).then(async(bizData) => {
            toast({
              title: '登录成功',
              status: 'success'
            })
            storage.setToken(bizData[appConfig.ACCESS_TOKEN_NAME], true)
            const res1 = await getInfo()
            userStorage.setUserInfo(res1)
            try {
              const res2 = await getMainChart()
              baseStorage.set('mainChart', res2)
            } catch (error) {
              console.log(error)
            }
            location.reload()
          }).catch(e => {
            console.log(e)
            toast({
              title: e.msg,
              status: 'error'
            })
          }).finally(() => {
            actions.setSubmitting(false)
          })
          // setTimeout(() => {
          //   alert(JSON.stringify(values, null, 2))
          // }, 1000)
        }}
        >
          {(props) => {
            return (
              <Form>
                <Flex
                  maxW={{ base: "100%", md: "max-content" }}
                  w='100%'
                  mx={{ base: "auto", lg: "0px" }}
                  me='auto'
                  h='100%'
                  alignItems='center'
                  justifyContent='center'
                  mb={{ base: "30px", md: "60px" }}
                  px={{ base: "25px", md: "0px" }}
                  mt={{ base: "40px", md: "14vh" }}
                  flexDirection='column'>
                  <Box me='auto'>
                    <Heading color={textColor} fontSize='36px' mb='10px'>
                      Moonbamboo支付系统
                    </Heading>
                    <Text
                      mb='36px'
                      ms='4px'
                      color={textColorSecondary}
                      fontWeight='400'
                      fontSize='md'>
                      商户系统
                    </Text>
                  </Box>
                  <Flex
                    zIndex='2'
                    direction='column'
                    w={{ base: "100%", md: "420px" }}
                    maxW='100%'
                    background='transparent'
                    borderRadius='15px'
                    mx={{ base: "auto", lg: "unset" }}
                    me='auto'
                    mb={{ base: "20px", md: "auto" }}>
                    <Box mb="20px">
                      <Field name='username' validate={val => validateEmptyVal(val, '账号')}>
                        {({ field, form }) => {
                          return (
                            <FormControl isInvalid={form.errors.username && form.touched.username}>
                              <FormLabel
                                display='flex'
                                ms='4px'
                                fontSize='sm'
                                fontWeight='500'
                                color={textColor}
                                mb='8px'>
                                账号<Text color={brandStars}>*</Text>
                              </FormLabel>
                              <Input 
                                {...field} 
                                placeholder='请输入账号'
                                fontSize='sm'
                                size='lg'
                              />
                              <FormErrorMessage>{form.errors.username}</FormErrorMessage>
                            </FormControl>
                          )
                        }}
                      </Field>
                    </Box>
                    <Box mb="20px">
                      <Field name='password' validate={val => validateEmptyVal(val, '密码')}>
                        {({ field, form }) => {
                          return (
                            <FormControl isInvalid={form.errors.password && form.touched.password}>
                              <FormLabel
                                display='flex'
                                ms='4px'
                                fontSize='sm'
                                fontWeight='500'
                                color={textColor}
                                mb='8px'>
                                密码<Text color={brandStars}>*</Text>
                              </FormLabel>
                              <Input 
                                {...field} 
                                placeholder='请输入密码'
                                fontSize='sm'
                                size='lg'
                                type="password"
                              />
                              <FormErrorMessage>{form.errors.password}</FormErrorMessage>
                            </FormControl>
                          )
                        }}
                      </Field>
                    </Box>
                    <Box mb="20px">
                      <Field name='usercode' validate={val => validateEmptyVal(val, '验证码')}>
                        {({ field, form }) => {
                          return (
                            <FormControl isInvalid={form.errors.usercode && form.touched.usercode}>
                              <FormLabel
                                ms='4px'
                                fontSize='sm'
                                fontWeight='500'
                                color={textColor}
                                display='flex'>
                                验证码<Text color={brandStars}>*</Text>
                              </FormLabel>
                              <Flex justifyContent='space-between' align='center'>
                                <InputGroup size='md'>
                                  <Input
                                    {...field} 
                                    placeholder='请输入验证码'
                                    fontSize='sm'
                                    size='lg'
                                  />
                                </InputGroup>
                                <Box me='auto' justifyItems={'center'} alignContent={'center'} ml="20px" width="200px" height="48px" onClick={refVercode}>
                                  {
                                    isOverdue ? (
                                      <Image
                                        src={vercodeImgSrc}
                                        alt="Horizon UI"
                                        style={{ width: '100%', height: '100%' }}
                                      />
                                    ) : (
                                      <Text color={"gray.300"} fontSize={"14px"}>已过期 请刷新</Text>
                                    )
                                  }
                                </Box>
                              </Flex>
                              <FormErrorMessage>{form.errors.usercode}</FormErrorMessage>
                            </FormControl>
                          )
                        }}
                      </Field>
                    </Box>
                    <FormControl>
                      {/* <FormLabel
                        display='flex'
                        ms='4px'
                        fontSize='sm'
                        fontWeight='500'
                        color={textColor}
                        mb='8px'>
                        账号<Text color={brandStars}>*</Text>
                      </FormLabel>
                      <Input
                        isRequired={true}
                        variant='auth'
                        fontSize='sm'
                        ms={{ base: "0px", md: "0px" }}
                        type='email'
                        placeholder='请输入账号'
                        mb='24px'
                        fontWeight='500'
                        size='lg'
                      /> */}
                      {/* <FormLabel
                        ms='4px'
                        fontSize='sm'
                        fontWeight='500'
                        color={textColor}
                        display='flex'>
                        密码<Text color={brandStars}>*</Text>
                      </FormLabel>
                      <InputGroup size='md'>
                        <Input
                          isRequired={true}
                          fontSize='sm'
                          placeholder='请输入密码'
                          mb='24px'
                          size='lg'
                          type={show ? "text" : "password"}
                          variant='auth'
                        />
                        <InputRightElement display='flex' alignItems='center' mt='4px'>
                          <Icon
                            color={textColorSecondary}
                            _hover={{ cursor: "pointer" }}
                            as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                            onClick={handleClick}
                          />
                        </InputRightElement>
                      </InputGroup>
                      <FormLabel
                        ms='4px'
                        fontSize='sm'
                        fontWeight='500'
                        color={textColor}
                        display='flex'>
                        验证码<Text color={brandStars}>*</Text>
                      </FormLabel>
                      <Flex justifyContent='space-between' align='center' mb='24px'>
                        <InputGroup size='md'>
                          <Input
                            isRequired={true}
                            fontSize='sm'
                            placeholder='请输入验证码'
                            size='lg'
                            type='text'
                            variant='auth'
                          />
                        </InputGroup>
                        <Box me='auto' alignItems="center" ml="20px" width="100px" height="48px" onClick={refVercode}>
                          {
                            isOverdue ? (
                              <Image
                                src={vercodeImgSrc}
                                alt="Horizon UI"
                                style={{ width: '100%', height: '100%' }}
                              />
                            ) : (
                              <Text color={"gray.300"} fontSize={"14px"}>已过期 请刷新</Text>
                            )
                          }
                        </Box>
                      </Flex>
                      <Flex justifyContent='space-between' align='center' mb='24px'>
                        <FormControl display='flex' alignItems='center'>
                          <Checkbox
                            id='remember-login'
                            colorScheme='brandScheme'
                            me='10px'
                          />
                          <FormLabel
                            htmlFor='remember-login'
                            mb='0'
                            fontWeight='normal'
                            color={textColor}
                            fontSize='sm'>
                            自动登录
                          </FormLabel>
                        </FormControl>
                        <NavLink to='/auth/forgot-password'>
                          <Text
                            color={textColorBrand}
                            fontSize='sm'
                            w='124px'
                            fontWeight='500'
                            textAlign={'right'}>
                            忘记密码？
                          </Text>
                        </NavLink>
                      </Flex> */}
                      <Button
                        isLoading={props.isSubmitting}
                        type='submit'
                        fontSize='sm'
                        variant='brand'
                        fontWeight='500'
                        w='100%'
                        h='50'
                        mb='24px'
                        mt="20px"
                      >
                        登录
                      </Button>
                    </FormControl>
                    
                    <div style={{ textAlign: 'right' }}>
                      <Link color={textColorDetails} fontWeight='400' fontSize='14px' onClick={onOpen} cursor="pointer">
                        商户开通申请
                      </Link>
                    </div>
                    {/* <Flex
                      flexDirection='column'
                      justifyContent='center'
                      alignItems='start'
                      maxW='100%'
                      mt='0px'>
                      <Text color={textColorDetails} fontWeight='400' fontSize='14px'>
                        Not registered yet?
                        <NavLink to='/auth/sign-up'>
                          <Text
                            color={textColorBrand}
                            as='span'
                            ms='5px'
                            fontWeight='500'>
                            Create an Account
                          </Text>
                        </NavLink>
                      </Text>
                    </Flex> */}
                  </Flex>
                </Flex>
              </Form>
            )
          }}
      </Formik>

      {/* 商户开通申请抽屉 */}
      <Drawer
        isOpen={isOpen}
        placement='right'
        onClose={onClose}
        size='md'
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader borderBottomWidth='1px' fontSize='18px' fontWeight='bold'>商户开通申请</DrawerHeader>

          <DrawerBody>
            <Stack spacing="4">
              <Flex justify="space-between">
                <Box width="48%">
                  <FormControl isRequired isInvalid={!!formErrors.mchName}>
                    <FormLabel>商户名称</FormLabel>
                    <Input 
                      placeholder="请输入商户名称" 
                      value={mchData.mchName}
                      onChange={(e) => {
                        setMchData({...mchData, mchName: e.target.value});
                        if (formErrors.mchName) {
                          setFormErrors({...formErrors, mchName: ""});
                        }
                      }}
                    />
                    {formErrors.mchName && <FormErrorMessage>{formErrors.mchName}</FormErrorMessage>}
                  </FormControl>
                </Box>
                <Box width="48%">
                  <FormControl isRequired isInvalid={!!formErrors.loginUserName}>
                    <FormLabel>登录名</FormLabel>
                    <Input 
                      placeholder="请输入商户登录名" 
                      value={mchData.loginUserName}
                      onChange={(e) => {
                        setMchData({...mchData, loginUserName: e.target.value});
                        if (formErrors.loginUserName) {
                          setFormErrors({...formErrors, loginUserName: ""});
                        }
                      }}
                    />
                    {formErrors.loginUserName && <FormErrorMessage>{formErrors.loginUserName}</FormErrorMessage>}
                  </FormControl>
                </Box>
              </Flex>

              <Flex justify="space-between">
                <Box width="48%">
                  <FormControl isRequired isInvalid={!!formErrors.mchShortName}>
                    <FormLabel>商户简称</FormLabel>
                    <Input 
                      placeholder="请输入商户简称" 
                      value={mchData.mchShortName}
                      onChange={(e) => {
                        setMchData({...mchData, mchShortName: e.target.value});
                        if (formErrors.mchShortName) {
                          setFormErrors({...formErrors, mchShortName: ""});
                        }
                      }}
                    />
                    {formErrors.mchShortName && <FormErrorMessage>{formErrors.mchShortName}</FormErrorMessage>}
                  </FormControl>
                </Box>
                <Box width="48%">
                  <FormControl isRequired isInvalid={!!formErrors.contactName}>
                    <FormLabel>联系人姓名</FormLabel>
                    <Input 
                      placeholder="请输入联系人姓名" 
                      value={mchData.contactName}
                      onChange={(e) => {
                        setMchData({...mchData, contactName: e.target.value});
                        if (formErrors.contactName) {
                          setFormErrors({...formErrors, contactName: ""});
                        }
                      }}
                    />
                    {formErrors.contactName && <FormErrorMessage>{formErrors.contactName}</FormErrorMessage>}
                  </FormControl>
                </Box>
              </Flex>

              <Flex justify="space-between">
                <Box width="48%">
                  <FormControl isInvalid={!!formErrors.contactEmail}>
                    <FormLabel>联系人邮箱</FormLabel>
                    <Input 
                      placeholder="请输入联系人邮箱" 
                      value={mchData.contactEmail}
                      onChange={(e) => {
                        setMchData({...mchData, contactEmail: e.target.value});
                        if (formErrors.contactEmail) {
                          setFormErrors({...formErrors, contactEmail: ""});
                        }
                      }}
                    />
                    {formErrors.contactEmail && <FormErrorMessage>{formErrors.contactEmail}</FormErrorMessage>}
                  </FormControl>
                </Box>
                <Box width="48%">
                  <FormControl isRequired isInvalid={!!formErrors.contactTel}>
                    <FormLabel>联系人手机号</FormLabel>
                    <Input 
                      placeholder="请输入联系人手机号" 
                      value={mchData.contactTel}
                      maxLength={11}
                      onChange={(e) => {
                        setMchData({...mchData, contactTel: e.target.value});
                        if (formErrors.contactTel) {
                          setFormErrors({...formErrors, contactTel: ""});
                        }
                      }}
                    />
                    {formErrors.contactTel && <FormErrorMessage>{formErrors.contactTel}</FormErrorMessage>}
                  </FormControl>
                </Box>
              </Flex>

              {/* <Flex justify="space-between" flexWrap="wrap" gap="20px 0">
                <Box width="48%" position="relative">
                  <FormControl>
                    <FormLabel>商户类型</FormLabel>
                    <RadioGroup value={mchData.type} onChange={(val) => setMchData({...mchData, type: parseInt(val)})}>
                      <Stack direction='row'>
                        <Radio value={1}>普通商户</Radio>
                        <Radio value={2}>特约商户</Radio>
                      </Stack>
                    </RadioGroup>
                  </FormControl>
                </Box>
                {mchData.type === 2 && (
                  <Box width="48%">
                    <FormControl isInvalid={!!formErrors.isvNo}>
                      <FormLabel>服务商号</FormLabel>
                      <Select 
                        placeholder="请选择服务商" 
                        value={mchData.isvNo}
                        onChange={(e) => {
                          setMchData({...mchData, isvNo: e.target.value});
                          if (formErrors.isvNo) {
                            setFormErrors({...formErrors, isvNo: ""});
                          }
                        }}
                      >
                        {isvList.map(isv => (
                          <option key={isv.isvNo} value={isv.isvNo}>
                            {isv.isvName + " [ ID: " + isv.isvNo + " ]"}
                          </option>
                        ))}
                      </Select>
                      {formErrors.isvNo && <FormErrorMessage>{formErrors.isvNo}</FormErrorMessage>}
                    </FormControl>
                  </Box>
                )}
                <Box width="48%">
                  <FormControl>
                    <FormLabel>状态</FormLabel>
                    <RadioGroup value={mchData.state} onChange={(val) => setMchData({...mchData, state: parseInt(val)})}>
                      <Stack direction='row'>
                        <Radio value={1}>启用</Radio>
                        <Radio value={0}>禁用</Radio>
                      </Stack>
                    </RadioGroup>
                  </FormControl>
                </Box>
                <Box width="48%">
                  <FormControl>
                    <FormLabel>是否记录余额明细</FormLabel>
                    <Switch 
                      isChecked={!!mchData.isRecordBalance} 
                      onChange={(e) => setMchData({...mchData, isRecordBalance: e.target.checked ? 1 : 0})} 
                    />
                  </FormControl>
                </Box>
              </Flex> */}

              <FormControl>
                <FormLabel>备注</FormLabel>
                <Textarea 
                  placeholder="请输入备注" 
                  value={mchData.remark}
                  onChange={(e) => setMchData({...mchData, remark: e.target.value})}
                />
              </FormControl>
            </Stack>
          </DrawerBody>

          <DrawerFooter borderTopWidth='1px'>
            <Button variant='outline' mr={3} onClick={onClose}>
              取消
            </Button>
            <Button colorScheme='blue' isLoading={isSubmitting} onClick={handleSubmitMch}>
              保存
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </DefaultAuth>
  );
}

export default SignIn;
